import {useCallback, useEffect} from "react";
import {batch, useSignal} from "@preact/signals-react";
import {useAppToast} from "@ui-seeker/app"
import {postSubmit} from "@ui-seeker/utils";

import {BACKEND_APIS} from "@constants";
import {isLoadMoreItems, reverseMatcherItems, reverseMatcherGroupedProductIDs} from "../@signals";
import useReverseMatcherItems from "./useItems";


export default function useReverseMatcherTarget() {
	const { handleSubmit, handleMoreProducts } = useReverseMatcherItems()
	const { showToast } = useAppToast()

	const selected = useSignal(null)
	const isQA = useSignal(false)
	const isLoadingMapping = useSignal(false)
	const targetIndex = useSignal(0)
	const targetData = reverseMatcherItems.value[targetIndex.value] || {}

	useEffect(() => {
		setSelectedSKU(targetData?.AIOptions?.[0]?.productID ?? null, false)
		if ((targetIndex.value + 1) > reverseMatcherItems.value.length)
			handleSubmit()
	}, [targetIndex.value])

	const __showToast = () => showToast.error(
		`SID: ${targetData.siteID} SKUID: ${targetData.skuID} Failed!`, {
			position: "top-left"
		})

	const setSelectedSKU = useCallback((newValue, saveByQa=true) => {
		selected.value = newValue
		isQA.value = saveByQa
	}, [])

	const setTargetIndex = useCallback(newValue => {
		targetIndex.value = newValue
		batch(() => isLoadingMapping.value = false)
	}, [JSON.stringify(targetData)])

	const saveMapping = useCallback((notFound=false) => {
		isLoadingMapping.value = true

		const productID = !notFound ? selected.value : null
		const additionalProductIDs = [...reverseMatcherGroupedProductIDs.value]
		setTargetIndex(targetIndex.value + 1)

		// Clear grouped product IDs after capturing them
		reverseMatcherGroupedProductIDs.value = []

		// Single API call - backend handles SKU_MAPPING update via ia-normalizer
		postSubmit(`${BACKEND_APIS.MATCHERS}/reverse/mapping-product`, {
			productID: productID,
			mappingID: targetData.mappingID,
			siteID: targetData.siteID,
			skuID: targetData.skuID,
			brandID: targetData.brandID,
			productURL: "",
			notFound: notFound,
			qa: true,
			additionalProductIDs: additionalProductIDs
		}).catch(e => {
			console.error('ERROR MAPPING SKU', e)
			__showToast()
		})
	}, [JSON.stringify(targetData), selected.value])

	return {
		targetIndex: targetIndex.value,
		targetData: targetData,
		selectedSKU: selected.value,
		isLoadingMapping: isLoadingMapping.value,

		finishItems: !isLoadMoreItems.value && targetIndex.value >= reverseMatcherItems.value.length,
		needMorItems: isLoadMoreItems.value && targetIndex.value >= reverseMatcherItems.value.length,

		setSelectedSKU,
		setTargetIndex,
		saveMapping,
		handleMoreProducts
	}
}